import { create } from 'zustand';
import { api } from '@/lib/api';

interface WishlistStore {
  ids: Set<number>;
  loaded: boolean;
  loadIds: () => Promise<void>;
  toggle: (productId: number) => Promise<boolean>;
  has: (productId: number) => boolean;
  clear: () => void;
}

export const useWishlistStore = create<WishlistStore>()((set, get) => ({
  ids: new Set(),
  loaded: false,

  loadIds: async () => {
    try {
      const ids = await api.getWishlistIds();
      set({ ids: new Set(ids), loaded: true });
    } catch {
      // Not authenticated or error — ignore
      set({ loaded: true });
    }
  },

  toggle: async (productId: number) => {
    const current = get().ids;
    const isInWishlist = current.has(productId);

    // Optimistic update
    const next = new Set(current);
    if (isInWishlist) {
      next.delete(productId);
    } else {
      next.add(productId);
    }
    set({ ids: next });

    try {
      if (isInWishlist) {
        await api.removeFromWishlist(productId);
        return false;
      } else {
        await api.addToWishlist(productId);
        return true;
      }
    } catch {
      // Revert on error
      set({ ids: current });
      throw new Error(isInWishlist ? 'Kunde inte ta bort från önskelistan' : 'Kunde inte lägga till i önskelistan');
    }
  },

  has: (productId: number) => get().ids.has(productId),

  clear: () => set({ ids: new Set(), loaded: false }),
}));
